<template>
    <div class="customer-entitlements">
        <v-card>
            <v-card-title class="pt-2 pb-2">
                <TippTitle
                        position="bottom"
                        :tipp="about"
                        title="Entitlements (Berechtigungen)"
                        :loading="loading"
                        :reloadCb="getEntitlements"
                />
            </v-card-title>
            <v-card-text class="pt-0">
                <KeineDaten v-if="entitlements.length <= 0"></KeineDaten>
                <v-data-table
                    v-if="entitlements.length > 0"
                    hide-default-footer
                    disable-pagination
                    :headers="headers"
                    :items="entitlements"
                >
                    <template slot="item" slot-scope="props">
                        <tr :class="props.item.class">
                            <td>{{ props.item.store_id }}</td>
                            <td>{{ props.item.entitlement_id }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import KeineDaten from '@/components/customer/KeineDaten.vue';
import TippTitle from '@/components/TippTitle.vue';

export default {
    name: 'Entitlements',
    components: {
        KeineDaten,
        TippTitle,
    },
    data() {
        return {
            about: 'Zeigt Nutzungsrechte und Informationen zu CeleraOne und Produkten an, die dem Benutzer zugewiesen wurden.',
            headers: [{
                text: 'Store-ID',
                align: 'left',
                sortable: false,
                value: 'store_id',
            }, {
                text: 'Enitlement-ID',
                align: 'left',
                sortable: false,
                value: 'entitlement_id',
            }],
        };
    },
    methods: mapActions('customerDetail', ['getEntitlements']),
    computed: {
        ...mapGetters('customerDetail', ['entitlements']),
        ...mapState('customerDetail', {
            loading: state => state.entitlements.loading,
        }),
    },
};
</script>

<style scoped lang="scss"></style>
